export const ATTENDEE_MODES = ['payer', 'individual', 'later'] as const

export type AttendeeMode = (typeof ATTENDEE_MODES)[number]

// Only `individual` invites. The legacy flag stays so an old server still does the right thing.
export const legacyAttendeeEmailFlag = (mode: AttendeeMode): boolean => mode === 'individual'

export const ATTENDEE_MODE_COPY = {
  get legend(): string {
    return I18n.t('react.shop.payment.form.attendee_mode.question')
  },
  payer: {
    get label(): string {
      return I18n.t('react.shop.payment.form.attendee_mode.payer')
    },
    get helper(): string {
      return I18n.t('react.shop.payment.form.attendee_mode.payer_hint')
    },
  },
  individual: {
    get label(): string {
      return I18n.t('react.shop.payment.form.attendee_mode.individual')
    },
    get helper(): string {
      return I18n.t('react.shop.payment.form.agree_receive_email')
    },
  },
  later: {
    get label(): string {
      return I18n.t('react.shop.payment.form.attendee_mode.later')
    },
    get helper(): string {
      return I18n.t('react.shop.payment.form.attendee_mode.later_hint')
    },
  },
  get laterUnavailableNotice(): string {
    return I18n.t('react.shop.payment.form.attendee_mode.later_unavailable')
  },
} as const
